import { TextBoxBaseCustomElement } from 'General/Resources/Elements/TextBox/TextBoxBase';
import { customElement } from 'aurelia-framework';

@customElement('text-box')
export class TextBoxCustomElement extends TextBoxBaseCustomElement {}